import React from 'react';
import { AwardIcon, BriefcaseIcon, GraduationCapIcon } from 'lucide-react';
export const About = () => {
  return <section id="about" className="py-20 bg-gray-800" data-id="element-9">
      <div className="container mx-auto px-4" data-id="element-10">
        <h2 className="text-4xl font-bold mb-2 text-center" data-id="element-11">About Me</h2>
        <p className="text-gray-400 text-center mb-12" data-id="element-12">
          Sparrymation | Søren Bro Sparre
        </p>
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-13">
          {/* Profile Image */}
          <div className="w-full lg:w-1/3 flex justify-center" data-id="element-14">
            <div className="relative" data-id="element-15">
              <div className="w-64 h-64 rounded-full overflow-hidden border-4 border-indigo-500" data-id="element-16">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mwAAGMsM47vqGzY5GkH8zF/41925217_10156014440968020_1840664451527737344_n_%281%29.jpg" alt="Søren Bro Sparre - 3D Animator" className="w-full h-full object-cover" data-id="element-17" />
              </div>
              <div className="absolute -bottom-4 -right-4 bg-indigo-600 text-white rounded-full w-24 h-24 flex items-center justify-center" data-id="element-18">
                <div className="text-center" data-id="element-19">
                  <div className="text-xl font-bold" data-id="element-20">5+</div>
                  <div className="text-xs" data-id="element-21">Years Exp.</div>
                </div>
              </div>
            </div>
          </div>
          {/* About Text */}
          <div className="w-full lg:w-2/3" data-id="element-22">
            <h3 className="text-2xl font-bold mb-4" data-id="element-23">
              Bringing Stories to Life Through Animation
            </h3>
            <p className="text-gray-300 mb-6" data-id="element-24">
              I'm Søren Bro Sparre, a passionate 3D animator with professional
              experience creating animations for video games, films, and
              television series. My work focuses on creating expressive
              character animations and contributing to visual storytelling
              through layout and previsualization.
            </p>
            <p className="text-gray-300 mb-8" data-id="element-25">
              After graduating from The Animation Workshop with honors, I've
              worked with leading studios like Paramount Animation and The Odd
              Gentlemen. I specialize in both keyframe animation and motion
              capture integration, with a keen focus on acting, timing, and body
              language.
            </p>
            {/* Skills & Experience */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-26">
              <div className="bg-gray-700/50 p-6 rounded-lg" data-id="element-27">
                <div className="flex items-center mb-4" data-id="element-28">
                  <BriefcaseIcon className="text-indigo-400 mr-3" size={24} data-id="element-29" />
                  <h4 className="text-xl font-semibold" data-id="element-30">Experience</h4>
                </div>
                <ul className="text-gray-300 space-y-2" data-id="element-31">
                  <li data-id="element-32">Character Animation</li>
                  <li data-id="element-33">Layout & Previsualization</li>
                  <li data-id="element-34">Motion Capture</li>
                  <li data-id="element-35">Game Animation</li>
                </ul>
              </div>
              <div className="bg-gray-700/50 p-6 rounded-lg" data-id="element-36">
                <div className="flex items-center mb-4" data-id="element-37">
                  <GraduationCapIcon className="text-indigo-400 mr-3" size={24} data-id="element-38" />
                  <h4 className="text-xl font-semibold" data-id="element-39">Education</h4>
                </div>
                <ul className="text-gray-300 space-y-2" data-id="element-40">
                  <li data-id="element-41">Bachelor in Character Animation</li>
                  <li data-id="element-42">The Animation Workshop</li>
                  <li data-id="element-43">Highest Grade: 12 (A)</li>
                </ul>
              </div>
              <div className="bg-gray-700/50 p-6 rounded-lg" data-id="element-44">
                <div className="flex items-center mb-4" data-id="element-45">
                  <AwardIcon className="text-indigo-400 mr-3" size={24} data-id="element-46" />
                  <h4 className="text-xl font-semibold" data-id="element-47">Software</h4>
                </div>
                <ul className="text-gray-300 space-y-2" data-id="element-48">
                  <li data-id="element-49">Maya</li>
                  <li data-id="element-50">Blender</li>
                  <li data-id="element-51">Unity Engine</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};